import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
const CoCreatedGuideLines: React.FC = React.memo(() => {

    return (
        <Box sx={{ mt: 2, mb: 4 }}>
            {/* Development Guidelines Section */}
            <Typography variant="h6" sx={{ mt: 0, color: "#0b3452", fontWeight: "bold" }}>
                AA journey Development Guidelines
            </Typography>

            <Box sx={{ mt: 2 }}>
                <Paper sx={{
                    borderRadius: '4px',
                    overflow: 'hidden'
                }}>
                    <Box sx={{ p: 2 }}>
                        {/* UX Guidelines */}
                        <Typography variant="h6" sx={{ color: "#0b3452", fontWeight: "bold" }}>
                            UX AA Sahamati Guidelines
                        </Typography>
                        <Typography sx={{ mt: 2, mb: 3, color: '#555' }}>
                            While developing AA screens, please follow the UX AA guidelines by referring to the {' '}
                            <a
                                href="https://workdrive.zohopublic.in/external/sheet/e0c838a03871e6258f44ff5b62042f2b89817a37c027e035c01e7d5ed9ce338f"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: '#0066cc', textDecoration: 'underline' }}
                            >
                                Sahamati Guidelines
                            </a>
                        </Typography>

                        {/* Code Guidelines */}
                        <Typography variant="h6" sx={{ mt: 4, color: "#0b3452", fontWeight: "bold" }}>
                            Code Guidelines
                        </Typography>

                        <Box sx={{ mt: 2 }}>
                            <Typography variant="subtitle1" sx={{ color: "#0b3452", fontWeight: "bold" }}>
                                1. Avoid Third-Party Imports, Code, or API Requests in the AA Journey
                            </Typography>
                            <Typography sx={{ mt: 1, mb: 3, color: '#555' }}>
                                <ul>
                                    <li>In the AA journey screens, ensure that <strong>only AA flow-related code</strong> is present.</li>
                                    <li>This means no third-party API requests that do not directly relate to the AA journey.</li>
                                </ul>
                            </Typography>

                            <Typography variant="subtitle1" sx={{ color: "#0b3452", fontWeight: "bold" }}>
                                2. Storage and Handling of User Data
                            </Typography>
                            <Typography sx={{ mt: 1, mb: 3, color: '#555' }}>
                                <ul>
                                    <li>Do not store user data in any kind of web storage, including cookies, local storage, session storage, or IndexedDB.</li>
                                </ul>
                            </Typography>

                            <Typography variant="subtitle1" sx={{ color: "#0b3452", fontWeight: "bold" }}>
                                3. Consent-Based Processing
                            </Typography>
                            <Typography sx={{ mt: 1, mb: 3, color: '#555' }}>
                                <ul>
                                    <li>Do not attempt to access or process any user account for which explicit consent has not been given.</li>
                                    <li>All data access must map directly to the consent artefact (Consent ID, data range, fetch frequency, expiry).</li>
                                </ul>
                            </Typography>

                            <Typography variant="subtitle1" sx={{ color: "#0b3452", fontWeight: "bold" }}>
                                4. Retry and Error Handling
                            </Typography>
                            <Typography sx={{ mt: 1, mb: 3, color: '#555' }}>
                                <ul>
                                    <li>Do not perform uncontrolled retries.</li>
                                    <li>All retries must follow a controlled, well-defined mechanism, including: Backoff delays, or Explicit user action (e.g., “Retry” button).</li>
                                </ul>
                            </Typography>

                            <Typography variant="subtitle1" sx={{ color: "#0b3452", fontWeight: "bold" }}>
                                5. Protection of Personally Identifiable Information (PII)
                            </Typography>
                            <Typography sx={{ mt: 1, mb: 3, color: '#555' }}>
                                <ul>
                                    <li>Do not share user PII data with the parent application (or any external system) via events, API calls, or any other channel unless the customer has explicitly consented.</li>
                                    <li>Do not log PII in any form in application logs, monitoring tools, or audit trails.</li>
                                </ul>
                            </Typography>
                        </Box>

                        {/* Co-Creation Guidelines */}
                        <Typography variant="h6" sx={{ mt: 4, color: "#0b3452", fontWeight: "bold" }}>
                            Co-Creation Code Push to Repo
                        </Typography>
                        <Typography sx={{ mt: 2, mb: 3, color: '#555' }}>
                            We will create a GitHub repository named <code>fiu_journey_fiuname</code> and share it with you for
                            pushing your AA journey code for review.
                        </Typography>

                        {/* Code Review Process */}
                        <Typography variant="h6" sx={{ mt: 4, color: "#0b3452", fontWeight: "bold" }}>
                            Code Review Process
                        </Typography>
                        <Typography sx={{ mt: 2, mb: 3, color: '#555' }}>
                            Please create a feature branch from main always, once code is developed raise a PR for main and and add us the reviewers.
                            Reviewers will review the code and if everything is good, they will merge the code to the main branch.
                        </Typography>

                        {/* UI Review Process */}
                        <Typography variant="h6" sx={{ mt: 4, color: "#0b3452", fontWeight: "bold" }}>
                            UI Review Process
                        </Typography>
                        <Typography sx={{ mt: 2, color: '#555' }}>
                            For each pull request created in the GitHub co-creation repository, please attach a screen recording
                            of the AA journey screens. Additionally, kindly share these screen recordings in the designated
                            communication channels (e.g., WhatsApp) for review.
                        </Typography>
                    </Box>
                </Paper>
            </Box>
        </Box>
    );
});

export default CoCreatedGuideLines;
